import { OnboardingImage } from './OnboardingImage';

const OnboardingAssessmentsImage = ({ style }) => {
  const twoX = {
    es: require('./es/onboarding-assessments@2x.jpg'),
    fr: require('./fr/onboarding-assessments@2x.jpg'),
    en: require('./onboarding-assessments@2x.jpg')
  };
  const threeX = {
    es: require('./es/onboarding-assessments@3x.jpg'),
    fr: require('./fr/onboarding-assessments@3x.jpg'),
    en: require('./onboarding-assessments@3x.jpg')
  };
  return <OnboardingImage twoX={twoX} threeX={threeX} style={style} />;
};

export { OnboardingAssessmentsImage };
